// Runs before Trustoo's deferred renderer, after its inline settings are parsed.
// Use Trustoo's conditional rendering: an unrated product gets no summary DOM.
// Reviewed products keep the app's existing markup, styling and interaction.
if (window.vstar_review_settings) {
  window.vstar_review_settings.is_show_stars_without_review = 2;
}
